<template>
    <div>
        <div v-for="[date, slots] in Object.entries(groupedSlots)" :key="date" class="calendar-day">
            <CalendarDay :slots="slots" :date="date" :mode="mode" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CalendarDay from '@/components/Calendar/CalendarDay.vue'

export default {
    components: {
        CalendarDay
    },
    props: {
        // used for removing dates in the calendar
        excludeDates: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
        // sets slot type to this
        mode: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        ...mapGetters({
            slotsGrid: 'general/slotsGrid'
        }),
        groupedSlots() {
            let data = this.slotsGrid.get()

            // remove excluded dates
            if (this.excludeDates.length > 0) {
                data = data.filter((item) => this.excludeDates.indexOf(item.date) === -1)
            }

            // group data by the date
            return data.groupBy('date').all()
        }
    }
}
</script>
